import { FC } from 'react';
import { Link } from 'react-scroll';
import Box from '@/components/UI/box/Box';
import Divider from '@/components/UI/divider/Divider';
import Icon from '@/components/UI/icon/Icon';
import Typography from '@/components/UI/typography/Typography';
import MidtermDiscount from './midtermDiscount/MidtermDiscount';
import styles from './TitleReviewsAndLocation.module.scss';
import { ProductItemTypes } from '@/components/houses/_types/productItem.types';
import { useMidTermQuery } from '@/components/houses/_hooks/useMidterm';
import { addCommas } from '@persian-tools/persian-tools';
type Props = {
  productState: ProductItemTypes;
};
const TitleReviewsAndLocation: FC<Props> = ({
  productState
}) => {
  const {
    isMidTerm
  } = useMidTermQuery(productState);
  return <Box className={styles['title-review-container']} data-sentry-element="Box" data-sentry-component="TitleReviewsAndLocation" data-sentry-source-file="TitleReviewsAndLocation.tsx">
      <Typography variant="title_Bold" component="h1" data-sentry-element="Typography" data-sentry-source-file="TitleReviewsAndLocation.tsx">
        {productState?.title} {!!isMidTerm && '(اجاره بلندمدت)'}
      </Typography>
      {isMidTerm && <Box className={styles['mid-term-discount-container']}>
          <Box className={styles['mid-term-price']}>
            <Typography variant="bodyM" color="neutral_600">
              اجاره ماهانه:
            </Typography>
            <Typography variant="bodyL_Bold" color="neutral_800">
              {addCommas(productState?.pricing?.records[0]?.total_monthly_price?.amount || 0)}
            </Typography>
            <Typography variant="bodyM" color="neutral_600">
              تومان
            </Typography>
          </Box>
          <Box className={styles['mid-term-original-price']}>
            <Typography variant="bodyM" color="neutral_500">
              {addCommas(productState?.pricing?.records[0]?.total_monthly_price_without_discount?.amount || 0)}
            </Typography>
            <Box className={styles.discount}>
              <MidtermDiscount pricing={productState?.pricing?.records[0]} />
            </Box>
          </Box>
        </Box>}
      <Box className={styles['rank-review-location']} data-sentry-element="Box" data-sentry-source-file="TitleReviewsAndLocation.tsx">
        {!productState?.reviews ? <Box className={styles['new-house']}>
            <Icon name="star-filled" type="primary" size="small" />
            <Typography variant="bodyM" color="secondary_main">
              اقامتگاه جدید
            </Typography>
          </Box> : <Link activeClass="active" smooth spy offset={-130} to={'comments'}>
            <Box className={styles['rank-review']}>
              <Icon name="star-filled" type="primary" size="small" />
              <Typography variant="bodyM" color="secondary_main">
                {productState?.rates?.rank}
              </Typography>
              <Typography variant="bodyM" color="neutral_500">
                ({productState?.reviews_count} نظر)
              </Typography>
            </Box>
          </Link>}

        <Divider orientation="vertical" data-sentry-element="Divider" data-sentry-source-file="TitleReviewsAndLocation.tsx" />

        <Box className={styles['location']} data-sentry-element="Box" data-sentry-source-file="TitleReviewsAndLocation.tsx">
          <Icon name="location" type="primary" data-sentry-element="Icon" data-sentry-source-file="TitleReviewsAndLocation.tsx" />
          <Link activeClass="active" smooth spy offset={-130} to={'location'} data-sentry-element="Link" data-sentry-source-file="TitleReviewsAndLocation.tsx">
            <Typography variant="bodyM" color="primary_main" data-sentry-element="Typography" data-sentry-source-file="TitleReviewsAndLocation.tsx">
              {!isMidTerm ? productState?.location?.city : ''}
              {productState?.location?.village !== '' && `${isMidTerm ? '' : '،'}  ${productState?.location?.village}`}{' '}
              (مشاهده نقشه)
            </Typography>
          </Link>
        </Box>
      </Box>
    </Box>;
};
export default TitleReviewsAndLocation;